// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/layout/Primary.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/layout/Primary.tsx");
  import.meta.hot.lastModified = "1727904225312.3235";
}
// REMIX HMR END

import React, { Fragment } from "react";
import PageHeader from "~/components/field/PageHeader";
import { ContentWrapper, CTA } from "~/components";
export default function Primary({
  node,
  children
}) {
  return <Fragment>
      {node.showTitle && <PageHeader title={node.title}>
          <p className="mt-4 text-center text-base">{node.summary}</p>
        </PageHeader>}
      <main>
        {children}
        {node.cta && <ContentWrapper className="bg-neutral-100" spacing="primary">
            <CTA {...node.cta} />
          </ContentWrapper>}
      </main>
    </Fragment>;
}
_c = Primary;
var _c;
$RefreshReg$(_c, "Primary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;